<template>
<div id="services">
    <div class="container">
        <div class="row">
            <div class="service-container">
                <div class="row">
                    <div class="col-md-4" v-on:click="scrollToComponent">
                        <router-link tag="div" to="vitrine">
                            <SiteVitrine />
                        </router-link>
                    </div>
                    <div class="col-md-4" v-on:click="scrollToComponent">
                        <router-link tag="div" to="ecommerce">
                            <Ecommerce />
                        </router-link>
                    </div>
                    <div class="col-md-4" v-on:click="scrollToComponent">
                        <router-link tag="div" to="gestion">
                            <AppGestion />
                        </router-link>
                    </div>
                </div>
                <div v-if="this.windowWidth > 1100">
                    <div class="row justify-content-center" style="">
                        <div class="col-md-4" v-on:click="scrollToComponent">
                            <router-link tag="div" to="digital">
                                <StrategieDigitale />
                            </router-link>
                        </div>
                        <div class="col-md-4" tag="div" v-on:click="scrollToComponent">
                            <AutresProjets />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row justify-content-center" style="">
                        <div class="col-md-5" v-on:click="scrollToComponent">
                            <router-link tag="div" to="digital">
                                <StrategieDigitale />
                            </router-link>
                        </div>
                        <div class="col-md-5" v-on:click="scrollToComponent">
                            <AutresProjets />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import SiteVitrine from './ServicePanels/SiteVitrine'
import Ecommerce from './ServicePanels/Ecommerce'
import AppGestion from './ServicePanels/AppGestion'
import StrategieDigitale from './ServicePanels/StrategieDigitale'
import AutresProjets from './ServicePanels/AutresProjets'

export default {
    components: {
        SiteVitrine,
        Ecommerce,
        AppGestion,
        StrategieDigitale,
        AutresProjets
    },
    mounted: function () {
        this.$data.windowWidth = window.innerWidth;
        let _this = this;
        window.addEventListener('resize', function () {
            _this.$data.windowWidth = window.innerWidth;
        });
    },
    methods: {
        scrollToComponent: function () {
            let panel = document.querySelectorAll('.services-title')[0];
            document.scrollTop = panel.scrollHeight;
            panel.scrollIntoView();
        }
    },
    data: function () {
        return {
            windowWidth: null
        }
    }
}
</script>

<style>
.element-container {
    width: 100%;
    text-align: center;
    margin-top: 100px;
}

.icon-container {
    width: 125px;
    height: 125px;
    border-radius: 100%;
    background-color: #03588C;
    margin: auto;
}

.service-container .icon-container>svg {
    width: 60px;
    height: 60px;
    margin-top: 35px;
    color: #f5f5f5;
}

.description>span {
    color: #81919a;
}

#services {
    padding-bottom: 5rem;
}

.service-container {
    margin: auto;
}

.service-container .element-container {
    cursor: pointer;
}

.element-container span {
    color: #34495E;
    text-decoration: none;
}

.details-panel {
    width: 100%;
    background-color: #03588C;
    color: #f5f5f5;
    margin-top: 5rem;
    margin-bottom: 5rem;
}

.title-container {
    width: 100%;
    margin-top: 50px;
    height: 110px;
    position: relative;
}

.title-container>svg {
    width: 100%;
    color: #f5f5f5;
    float: left;
    height: 100%;
    font-size: 2.5rem;
}

.title-container>span {
    float: left;
    line-height: 110px;
    font-size: 30px;
    font-weight: bold;
    margin-left: 25px;
}

.description-container {
    width: 100%;
    text-align: left;
    margin-top: 25px;
}

.description-container span {
    font-size: 25px;
}

.assets-container {
    margin-top: 50px;
    margin-bottom: 50px;
}

.asset {
    width: 100%;
    height: 50px;
    display: inline-block;
    margin-bottom: 15px;
}

.asset img {
    width: 40px;
    float: left;
}

.asset span {
    float: left;
    line-height: 40px;
    margin-left: 20px;
    font-size: 25px;
}

.close {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    color: #f5f5f5;
}

.close:hover {
    color: #f5f5f5;
}

.title {
    margin: auto;
    font-size: 1.6rem;
    margin-top: 15px;
    font-weight: bold;
    text-transform: uppercase;
}

.description {
    font-size: 1rem;
    margin: auto;
    margin-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
}

@media (max-width: 992px) {
    .title {
        font-size: 1.4rem;
    }

    .description {
        font-size: 0.9rem;
    }

    .title-container span {
        font-size: 1.4rem;
    }

    .description-container span {
        font-size: 1.2rem;
    }

    .asset span {
        font-size: 1.2rem;
        line-height: 30px;
    }

    .asset img {
        width: 30px;
    }

    .title-container>svg {
        font-size: 2.5rem;
    }
}

@media (max-width: 576px) {
    .title {
        font-size: 1.2rem;
    }

    .description {
        font-size: 0.9rem;
    }
}

@media (max-width: 380px) {
    .title-container span {
        font-size: 1.2rem;
    }

    .description-container span {
        font-size: 1rem;
    }

    .asset span {
        font-size: 1rem;
        line-height: 25px;
        margin-left: 10px;
    }

    .asset img {
        width: 25px;
    }
}

@media (max-width: 768px) {
    .element-container {
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Services.vue